import React from "react"
import styles from "./HeroSection.module.css"
import Container from "../Container/Container"
import Button from "../Button/Button"
import Img from "gatsby-image"
import PropTypes from "prop-types"
import { routes } from "../../../config"

const HeroSection = ({ preHeading, heading, content, imageCards }) => (
  <section className={styles.heroSection}>
    <Container>
      <h2 className={styles.preHeading}>{preHeading}</h2>
      <h1 className={styles.heading}>{heading}</h1>
      <p className={styles.content}>
        {content}
      </p>
      <div>
        <Button text={"Get Started"} link={routes.slack} className={styles.button}/>
      </div>
      <div className={styles.imageCards}>
        {
          (imageCards && imageCards.length > 0) && imageCards.map((image, i) =>
            <figure key={`heroImage${i}`} className={imageCards.length === 1 ? styles.single : ""}>
              <Img fluid={image.src} alt={image.alt}/>
              {image.title && <figcaption className={styles.imageTitle}>{image.title}</figcaption>}
            </figure>
          )
        }
      </div>
    </Container>
  </section>
)

HeroSection.propTypes = {
  preHeading: PropTypes.string,
  heading: PropTypes.string,
  content: PropTypes.any,
  imageCards: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    alt: PropTypes.string,
    title: PropTypes.string,
  })),
}

export default HeroSection